import React from 'react';
import './ticker.scss';

var Ticker = function Ticker(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("section", {
    className: "ticker"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ticker__scroll ticker__text1"
  }, /*#__PURE__*/React.createElement("div", null, children)));
};

export default Ticker;